module.exports = __webpack_public_path__ + "static/media/HTML5_Badge.52ee96f4.svg";